import React, { useState, useContext, useEffect } from 'react';

import { AppContext } from '../../../../RoutesWithAuth';

import axios from '../../../common/AxiosConfig';

import DataGrid from '../grid';

import { makeStyles } from "@mui/styles";

import { DATEFORMATLOCAL, DATEFORMATUTC, RequestorMapping,RequestTypeMapping } from '../../../common/commons';

import RowMenuCell from '../grid/RowEditActions';

import { LoadingIndicator } from '../reports/reconcilationreport/MuiStyled';

import moment from 'moment';

import { Tooltip } from '@mui/material';

import RequestTypeWrapper from './RequestTypeWrapper';

import { renderEditSingleSelectCell } from '../grid/EditSingleSelectCell';
import { ADMIN_PERMISSIONS } from '../../../common/RolePermissions';


const Requestor = [RequestorMapping.B2B, RequestorMapping.CUSTOMER, RequestorMapping.DRIVER, RequestorMapping.EMPLOYEE, "Survivor", RequestorMapping.TCICUSTOMER];
const DEACTIVATE_ACCOUNT = "Deactivate-Account";
const THRESHOLD_HOURS = Array.from({ length: 24 }, (_, i) => (i + 1).toString());
const DEACTIVATE_ACCOUNT_THRESHOLD_HOURS = Array.from({ length: 12 }, (_, i) => ((i + 1) * 2).toString());
const COLUMNS = [{
    name: "#",
    mapping: "rowId",
    width: 40
}, {
    name: 'Request Type',
    mapping: "request_type",
    renderCell: (params) => (
        <>
            {RequestTypeMapping[params.row["request_type"]]}
        </>
    ),
}, {
    name: 'Threshold Days',
    mapping: "threshold_time",
    editable: true,
    width: 160,
    type: 'singleSelect',
    valueOptions: Array.from({length:24},(_,i)=>(i+1).toString()),
}, {
    name: 'Updated By',
    mapping: "updated_by",
}, {
    name: 'Updated On',
    mapping: "updated_on",
    width: 200,
    renderCell: (params) => (

        <Tooltip title={params.row["updateDateLocal"]}>
            <span>
                {params.row["updatedDateUTC"]}
            </span>
        </Tooltip>
    ),
}, {
    name: "Edit",
    mapping: "actions",
    adminEnabled: true,
    width: 80,
    editable: false,
    renderCell: RowMenuCell
}];

const DRIVER_COLUMNS = [{
    name: "#",
    mapping: "rowId",
    width: 40
}, {
    name: 'Request Type',
    mapping: "request_type",
    renderCell: (params) => (
        <>
            {RequestTypeMapping[params.row["request_type"]]}
        </>
    ),
}, {
    name: 'Threshold Hours',
    mapping: "threshold_time",
    editable: true,
    width: 160,
    type: 'singleSelect',
    valueOptions: Array.from({length: 24}, (_, i) => (i + 1).toString()),
}, {
    name: 'Updated By',
    mapping: "updated_by",
}, {
    name: 'Updated On',
    mapping: "updated_on",
    width: 200,
    renderCell: (params) => (

        <Tooltip title={params.row["updateDateLocal"]}>
            <span>
                {params.row["updatedDateUTC"]}
            </span>
        </Tooltip>
    ),
}, {
    name: "Edit",
    mapping: "actions",
    adminEnabled: true,
    width: 80,
    editable: false,
    renderCell: RowMenuCell
}];

const SURVIVOR_COLUMNS = [{
    name: "#",
    mapping: "rowId",
    width: 40
}, {
    name: 'Request Type',
    mapping: "request_type",
    renderCell: (params) => (
        <>
            {RequestTypeMapping[params.row["request_type"]]}
        </>
    ),
}, {
    name: 'Threshold Hours',
    mapping: "threshold_time",
    editable: true,
    width: 160,
    type: 'singleSelect',
    getValueOptions: (row) => (
        row?.request_type === DEACTIVATE_ACCOUNT ? DEACTIVATE_ACCOUNT_THRESHOLD_HOURS : THRESHOLD_HOURS
    ),
    renderEditCell: renderEditSingleSelectCell,
}, {
    name: 'Updated By',
    mapping: "updated_by",
}, {
    name: 'Updated On',
    mapping: "updated_on",
    width: 200,
    renderCell: (params) => (

        <Tooltip title={params.row["updateDateLocal"]}>
            <span>
                {params.row["updatedDateUTC"]}
            </span>
        </Tooltip>
    ),
}, {
    name: "Edit",
    mapping: "actions",
    adminEnabled: true,
    width: 80,
    editable: false,
    renderCell: RowMenuCell
}];

const useStyles = makeStyles(() => ({
    appscopeWrapper: {
        // marginTop: '4px',
        // marginRight: '15px'
    },
    noteWrapper: {
        marginTop: '10px',
        fontStyle: 'italic'
    }
}));
function EscalationSettings({ activeTab, fromredirection, workflow }) {

    const [appsData, setAppsData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    
    const requestor = Requestor[activeTab];
    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const classes = useStyles()
    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, activeTab, fromredirection])
    
    const fetchData = () => {
        setIsProcessing(true);
        const params = {
            requestor
        }
        axios.get(`settings/escalation`, {
            headers: {
                Authorization: authToken
            },
            params
        }).then(res => {
            let appsData = res.data;
            setAppsData(appsData);
            setIsProcessing(false);

        }).catch(err => {
            setIsProcessing(false);
            console.log(err)
        })
    }
    const updateApp = (rowInfo) => {
        setIsProcessing(true);
        const payload = {
            requestor,
            request_type : rowInfo.request_type,
            threshold_time : rowInfo.threshold_time,
            ...(requestor === RequestorMapping.DRIVER && { notification_email: 'Telematics_CCPA_Operations_Team@toyota.com' })
        };
        
        axios.put(`settings/escalation`, payload , {
            headers: {
                Authorization: authToken
            }
        })
            .then(res => {
                fetchData();
                setIsProcessing(false);
            }).catch(err => {
                setIsProcessing(false);
                console.log(err)
            })
    }
    const dataGridColumns = () => {
        const permissionByRequestor = {
            [RequestorMapping.B2B]: ADMIN_PERMISSIONS.ESC_SETTINGS_B2B_EDIT,
            [RequestorMapping.CUSTOMER]: ADMIN_PERMISSIONS.ESC_SETTINGS_CUSTOMER_EDIT,
            [RequestorMapping.DRIVER]: ADMIN_PERMISSIONS.ESC_SETTINGS_DRIVER_EDIT,
            [RequestorMapping.EMPLOYEE]: ADMIN_PERMISSIONS.ESC_SETTINGS_EMPLOYEE_EDIT,
            Survivor: ADMIN_PERMISSIONS.ESC_SETTINGS_SURVIVOR_EDIT,
            [RequestorMapping.TCICUSTOMER]: ADMIN_PERMISSIONS.ESC_SETTINGS_TCI_CUSTOMER_EDIT,
        };
        const columns = requestor === "Survivor" ? SURVIVOR_COLUMNS : requestor === RequestorMapping.DRIVER ? DRIVER_COLUMNS : COLUMNS;
        return columns.map((column) => column.mapping === 'actions'
            ? { ...column, adminPermission: permissionByRequestor[requestor] }
            : column);
    }
    const appsGridData = () => {
        let data = appsData;
        if (requestor === "Survivor") {
            data = data?.filter(row => row.request_type !== "Right-to-Create");
        }
        return data?.map((row, i) => {
            return {
                rowId: (i + 1),
                originalId: row.id,
                id: `${(i + 1)}-${activeTab}`,
                ...row,
                updateDateLocal: row.updated_on ? moment(row.updated_on).local().format(DATEFORMATLOCAL) : '--',
                updatedDateUTC: row.updated_on ? moment(row.updated_on).utc().format(DATEFORMATUTC) : '--',
            }
        })
    }
    return (
        <div className={classes.appscopeWrapper} key={`EscalationSettings-${activeTab}`}>
            {isProcessing && (<LoadingIndicator />)}
            <DataGrid
                disableSelectionOnClick={false}
                columns={dataGridColumns()}
                rows={appsGridData()}
                onRowEditCommit={(rows, event) => {
                    if (event.rowInfo) {
                        updateApp(event.rowInfo);
                    }
                }}
            />
            <div className={classes.noteWrapper}>
                Note: CPS automatically sends an escalation email to downstream POCs if the response is pending for more than 'threshold {(requestor === "Survivor" || requestor === RequestorMapping.DRIVER) ?"hours":"days"}'.
            </div>
        </div>
    )
}
export default React.memo(EscalationSettings);

const EscalationSettingsWrapper = (parentprops) => {
    return (<RequestTypeWrapper
        additionalTab={[{
            name: "driver",
            display: "Driver"
        }, {
            name: "survivor",
            display: "survivor"
        }]}
        title={"ESCALATION SETTINGS"}
        routePath={"escalationsetting"}
        renderTabContent={(props) => {
            return <EscalationSettings
                {...props} />
        }}
        {...parentprops}
    />)
}
export const EscalationSettingsTab = React.memo(EscalationSettingsWrapper);